import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { map } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (_route, _state) => {
    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(map(() => true));
};
